import React, { SetStateAction, useEffect, useState, Dispatch } from "react";
import Select from "react-select";

export const ValueDisplaySelectSimple: React.FunctionComponent<{
  title: string;
  value: string;
  changesDone: boolean;
  keyName: string;
  editHandler: (value: string, key: string) => void;
  parentChangeNotifier: Dispatch<SetStateAction<boolean>>;
  highlighted?: boolean;
  readOnly?: boolean;
  data: any[];
  valueName: string;
}> = ({
  title,
  value,
  changesDone,
  parentChangeNotifier,
  editHandler,
  keyName,
  highlighted,
  readOnly,
  data,
  valueName,
}) => {
  const [isEditing, setIsEditing] = useState<boolean>(false);

  useEffect(() => {
    !changesDone && isEditing && setIsEditing(false);
  }, [changesDone]);

  const defaultSelected = data.find((item) => item[valueName] === value);

  return (
    <>
      <h4 className="font-bold mt-3">
        <span>{title}</span>
      </h4>
      {isEditing ? (
        <>
          <Select
            options={
              data &&
              data.map((item) => ({
                value: item.id,
                label: `${item[valueName]}`,
              }))
            }
            placeholder=""
            onChange={(e) => {
              parentChangeNotifier(true);
              e && editHandler(e.value, keyName);
            }}
            defaultValue={
              defaultSelected
                ? {
                    value: defaultSelected.id,
                    label: `${defaultSelected[valueName]}`,
                  }
                : undefined
            }
          />
        </>
      ) : (
        <h1
          className="w-full h-6 cursor-pointer"
          onClick={() => {
            !readOnly && setIsEditing(true);
          }}
        >
          {value}
        </h1>
      )}
    </>
  );
};
